export const NEW_SUBSCRIPTION_EVENT_DESTINATION = "AW-11179879045/G2yfCImNucEZEIXV_dIp";
